export const EMAIL_PREFERENCES_ROUTES = {
  __ROOT__: '/emailPreferenceMod',
}
